import React, { useState, useEffect, useContext } from 'react'
import { connect } from 'react-redux'

import { 
  getProvider, fetchProvider, fetchPublicClassList, getPublicClassList, 
  fetchTrainerIndex, fetchCourseIndex, getTrainerIndex, getCourseIndex
} from '../../../store/client'

import { NavigationContext } from '../../../shared/ui/NavigationController'
import Button from '../../../shared/ui/Button'
import Text from '../../../shared/ui/Text'
import Link from '../../../shared/ui/Link'
import Grid from '../../../shared/ui/Grid'
import Section from '../../../shared/ui/Section'
import { Tabs, Tab } from '../../../shared/ui/Tabs'

import CourseCard from './CourseCard'
import PublicClassCard from './PublicClassCard'

import { withStyles } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import Paper from '@material-ui/core/Paper'
import Avatar from '@material-ui/core/Avatar'
import LinearProgress from '@material-ui/core/LinearProgress'

const styles = theme => ({
  root: {
    position: 'relative'
  },
  headerTitle: {
    fontSize: theme.typography.h5.fontSize,    
    fontWeight: 600
  },
  headerHeadline: {
    fontSize: theme.typography.h6.fontSize,    
    fontWeight: 300,    
  },
  body: {
    padding: theme.spacing(3)
  },
  progressBar: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%'
  },
  linearProgress: {
    height: 2
  }
})

const TrainerItem = ({ theme, classes, item }) => {
  return (
    <Link to={`/trainer/${item.uid}/`}>
      <Box width='100%' display='flex' flexDirection='column' justifyContent='center' alignItems='center' 
        style={{
          position:'relative'
        }}>
        
          <Avatar src={item.profile_picture_url}
            style={{
              width: '100px',
              height: '100px'
            }}
          />        
          <Box mt={2} />
          <Typography variant='body1'>{item.first_name + ' '+ item.last_name}</Typography>
      </Box>
    </Link>
  )
}

const HeaderView = ({ theme, classes, data }) => {
  return (
    <div>
      <Box mt={0}>
          <Box style={{
            position:'relative',backgroundSize:"cover",backgroundPosition:'center',
            backgroundImage:"url("+(data && data.header_image ? data.header_image.image_url : '/assets/placeholder_2_banner.png')+ ")", 
            width:'100%', height:'0', paddingBottom:'33%', backgroundRepeat:'no-repeat'
            }}>
          </Box>
      </Box>
      <Box display='flex' flexDirection='row' style={{marginLeft:'16px', position:'relative'}}>
          <Box style={{
              backgroundColor:'white',
              border:'1px solid #eeeeee',
              width:'150px', 
              height:'150px',
              borderRadius: '75px',
              overflow: 'hidden' ,
              marginTop:'-8%'
            }}>
              <Box 
              style={{position:'relative',backgroundSize:"cover", 
                backgroundPosition:'center', width:'100%', height:'100%', 
                backgroundImage:"url("+(data && data.logo && data.logo.image_url || '/assets/placeholder_3_profile_icon.png')+ ")",
                }}>
              </Box>
          </Box>
          
          <Box style={{marginLeft:'16px', marginTop:'12px', width:'80%'}}>    
            <Typography component='h1' className={classes.headerTitle}>
              {data.name}
            </Typography>
            
            <Typography className={classes.headerHeadline}>
              {data.head_line}
            </Typography>
          </Box>
      </Box>
    </div>
  )
}

const ProviderDetailView = ({ theme, classes, ...props }) => {

  const { providerKey, fetchProvider, isFetching, lastFetched,
    fetchCourses, fetchTrainers, courseList, trainerList,
    fetchPublicClasses, upcoming, data } = props
  
  const navigationContext = useContext(NavigationContext)

  const [selectedGroupKey, setSelectedGroupKey] = useState("trainers")

  useEffect(() => {
    fetchProvider(true)
  }, [providerKey])  

  useEffect(() => {
    if (selectedGroupKey === 'trainers') {
      fetchTrainers()
    } else if (selectedGroupKey === 'upcoming') {
      fetchPublicClasses()
    } else {
      fetchCourses()
    }
  }, [selectedGroupKey])
    
  const smUp = useMediaQuery(theme.breakpoints.up('sm'))

  const groups = [
    { key: 'trainers', label: 'Our Trainers' },
    { key: 'upcoming', label: 'Upcoming Public Classes' },
    { key: 'courses', label: 'All Courses' },
  ]
  
  const getCourseDetailLink = (row) => {
    return `/course/${row.uid}`
  }
  
  const getTrainerDetailLink = (row) => {
    return `/trainer/${row.uid}`
  }
  
  let upcomingClass = upcoming.lastFetched ? upcoming.data.records : []
  let filterUpcoming = upcomingClass.filter(item => item.provider.uid === parseInt(providerKey) && item.submitted_at && !item.canceled_at && !item.completed_at)
  let filteredCourse = courseList.lastFetched ? courseList.data.records.filter(item => item.provider.uid === parseInt(providerKey) && item.ready_to_sell) : []
  let filteredTrainer = trainerList.lastFetched ? trainerList.data.records.filter(item => item.provider.uid === parseInt(providerKey)) : []
  
  let groupsWithCount = groups.map(g => {
    let count = 0
    if (g.key == 'upcoming')
      count = filterUpcoming.length
    else if (g.key == 'courses')
      count = filteredCourse.length
    else if (g.key == 'trainers')
      count = filteredTrainer.length
    const label = count > 0 ? `${g.label} (${count})` : g.label
    return { 
      ...g, label 
    }
  })
    
  return (
    <Box display='flex' className={classes.root}>
      <Box flexGrow={1}>
        <Paper elevation={2} style={{ overflow: 'hidden' }}>
          <HeaderView theme={theme} classes={classes}
            data={data}
          />
          <Box className={classes.body}>          
            <Section gutterBottom>
              <Section title="About" variant="subsection">
                <Text text={ data.summary } format='markdown'/>
              </Section>
            </Section>

            { groups && groups.length > 0 &&
                <Tabs value={
                    selectedGroupKey ? 
                      groups.findIndex(g => g.key == selectedGroupKey) : 0
                  }
                  onChange={(e, newValue) => {
                    setSelectedGroupKey(groups[newValue].key)
                  }}
                  >
                  { groups.map(g => (
                    <Tab label={g.label}
                      />
                  ))}        
                </Tabs>
              }
            
            <Box mt={2}>
              { selectedGroupKey === 'upcoming' &&
                <Box>
                  { upcoming.isFetching &&
                    <Box className={classes.progressBar}>
                      <LinearProgress className={classes.linearProgress}/>
                    </Box>
                  }
                  
                  <Grid 
                    size='medium'
                    items={filterUpcoming}
                    renderItem={(item, index) => (
                      <PublicClassCard theme={theme} classes={classes}
                          item={item}
                          linkTo={getCourseDetailLink(item.course)}
                          target={'_blank'}
                          variant='vertical'
                          />
                      )}
                  />

                  { upcoming.lastFetched && filterUpcoming.length <= 0 &&
                    <Box mt={3} display='flex' justifyContent='center' alignItems='center' flexDirection='column'>
                      <Typography variant='body1'>
                        No upcoming public classes.
                      </Typography>
                    </Box>
                  }
                  
                </Box>
              }

              { selectedGroupKey === 'courses' &&
                <Box>
                  { courseList.isFetching &&
                    <Box className={classes.progressBar}>
                      <LinearProgress className={classes.linearProgress}/>
                    </Box>
                  }
                  <Grid 
                    size='medium'
                    items={filteredCourse}
                    renderItem={(item, index) => (
                      <CourseCard theme={theme} classes={classes}
                          item={item}
                          linkTo={getCourseDetailLink(item)}
                          target={'_blank'}
                          variant='vertical'
                          />
                      )}
                  />

                  { courseList.lastFetched && filteredCourse.length <= 0 &&
                    <Box mt={3} display='flex' justifyContent='center' alignItems='center' flexDirection='column'>
                      <Typography variant='body1'>
                        No available course.
                      </Typography>
                    </Box>
                  }

                </Box>
              }

              { selectedGroupKey === 'trainers' &&
                <Box>
                  { trainerList.isFetching &&
                    <Box className={classes.progressBar}>
                      <LinearProgress className={classes.linearProgress} />
                    </Box>
                  }
                  <Grid 
                    size='medium'
                    items={filteredTrainer.filter(item => item.visibility !== 'private')}
                    renderItem={(item, index) => (
                      <TrainerItem theme={theme} classes={classes}
                          item={item}
                          linkTo={getTrainerDetailLink(item)}
                          target={'_blank'}
                          variant='horizontal'
                          />
                      )}
                  />

                  { trainerList.lastFetched && filteredTrainer.filter(item => item.visibility !== 'private').length <= 0 &&
                    <Box mt={3} display='flex' justifyContent='center' alignItems='center' flexDirection='column'>
                      <Typography variant='body1'>
                        No available trainer.
                      </Typography>
                    </Box>
                  }
                </Box>
              }
            </Box>

            {/* <Section title="Upcoming Public Classes" gutterBottom>
              <Grid
                size={'medium'} 
                maxRowCount={-1}
                items={filterUpcoming}
                renderItem={(item, index) => (
                <PublicClassCard theme={theme} classes={classes}
                    item={item}
                    linkTo={getCourseDetailLink(item)}
                    />
                )}
              />
            </Section>
            
            <Section title="Featured Courses" gutterBottom>
              <Grid
                size={'medium'} 
                maxRowCount={-1}
                items={filteredCourse}
                renderItem={(item, index) => (
                <CourseCard theme={theme} classes={classes}
                    item={item}
                    linkTo={getCourseDetailLink(item)}
                    />
                )}
              />
            </Section>    
            
            <Section title="Our Trainers" gutterBottom>

              <Grid
                size={'medium'} 
                maxRowCount={-1}
                items={filteredTrainer}
                renderItem={(item, index) => (
                  <TrainerItem theme={theme} classes={classes}
                    item={item}
                  />
                )}
              />
            </Section>  */}
          </Box>
        </Paper>
      </Box>
      {/*
      <Box flexShrink={0} style={{ width: '6%' }} />
      <Box flexShrink={0} style={{ width: '35%' }}>
        <Box mt={0}>        
          <OrderCard theme={theme} classes={classes}
            provider={data}
            />
        </Box>
      </Box>
      */}
    </Box>
  )
}

const mapStateToProps = (state, ownProps) => {
  let providerKey = ownProps.providerKey

  return {
    providerKey,
    ...getProvider(state,providerKey),
    upcoming: getPublicClassList(state),
    trainerList: getTrainerIndex(state, '', null),
    courseList: getCourseIndex(state, '', null)
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  let providerKey = ownProps.providerKey
  
  return {
    fetchProvider:() => {
      dispatch(fetchProvider(providerKey, true, null))
    },
    fetchPublicClasses: () => {
      dispatch(fetchPublicClassList(true))
    },
    fetchTrainers: () => {
      dispatch(fetchTrainerIndex('', null, true))
    },
    fetchCourses: () => {
      dispatch(fetchCourseIndex('',null, true))
    }
  }
}

export default withStyles(styles, { withTheme: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps
   )(ProviderDetailView)
)
